// src/App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Login from "./components/Login";
import Signup from "./components/Signup";
import Dashboard from "./components/Dashboard";
import Gallery from "./Gallery";
import { GlobalProvider } from "./GlobalContext";
import Dashpoard from "./admin/Dashpoard";

function App() {
  // حالة تسجيل الدخول
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // عند تحميل التطبيق، تحقق من localStorage
  useEffect(() => {
    const storedLogin = localStorage.getItem("isLoggedIn");
    if (storedLogin === "true") {
      setIsLoggedIn(true);
    }
  }, []);

  return (
    <GlobalProvider>
      <Router>
        <div className="app">
          <Routes>
            {/* الصفحة الرئيسية */}
            <Route
              path="/"
              element={
                <>
                  <Header />
                  <main>
                    <Hero />
                  </main>
                </>
              }
            />

            {/* صفحة تسجيل الدخول */}
            <Route
              path="/login"
              element={
                <>
                  <Header />
                  <main>
                    <Login setIsLoggedIn={setIsLoggedIn} />
                  </main>
                </>
              }
            />

            {/* صفحة التسجيل */}
            <Route
              path="/signup"
              element={
                <>
                  <Header />
                  <main>
                    <Signup />
                  </main>
                </>
              }
            />

            {/* صفحة معرض الصور */}
            <Route
              path="/gallery"
              element={
                <>
                  <Header />
                  <main>
                    <Gallery />
                  </main>
                </>
              }
            />

            {/* الداشبورد بدون هيدر */}
            <Route
              path="/dashboard"
              element={
                isLoggedIn ? (
                  <Dashboard setIsLoggedIn={setIsLoggedIn} />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />

            {/* Dashpoard الإداري */}
            <Route
              path="/dashpoard"
              element={
                isLoggedIn ? (
                  <Dashpoard setIsLoggedIn={setIsLoggedIn} />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />

            {/* أي مسار غير معروف */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </GlobalProvider>
  );
}

export default App;
